import React from 'react';
import { ReportingContainerBaseConfig } from '../../../../../base';
import { SharePopoverController, SharePopoverLoader } from './sharePopoverInterface';
import { SharePopoverContainerProps } from './sharePopoverProps';
import { useDisclosure } from '@chakra-ui/react';

export function createSharePopoverContainer(
    config: ReportingContainerBaseConfig,
    loader: SharePopoverLoader,
    controller: SharePopoverController
): React.FC<SharePopoverContainerProps> {
    const {
        kernel: {
            infra: {
                toaster: { useToast },
            },
        },
        context: { useContext },
        repository: { research: repository },
    } = config;
    return ({ as: View, children, ...containerProps }) => {
        const toast = useToast();
        const context = useContext();
        const mutation = {
            form: {
                update: repository.form.useUpdate(context),
            },
        };
        const data = loader.useLoad(context, containerProps);
        const props = controller.useProps(context, data, {
            disclosure: {
                popover: useDisclosure(),
            },
            field: {
                captureEmail: {
                    value: data.form.config.capture_email,
                    async onChange(value) {
                        try {
                            const response = await mutation.form.update.mutateAsync({
                                formId: data.form.id,
                                payload: {
                                    config: {
                                        ...data.form.config,
                                        capture_email: value,
                                    },
                                },
                            });
                        } catch (error) {
                            console.error(error);
                            toast({
                                kind: 'error',
                                description: 'An unexpected error occurred',
                            });
                        }
                    },
                },
                accessLevel: {
                    value: data.form.config.access_level,
                    async onChange(value) {
                        try {
                            await mutation.form.update.mutateAsync({
                                formId: data.form.id,
                                payload: {
                                    config: {
                                        ...data.form.config,
                                        access_level: value,
                                    },
                                },
                            });
                        } catch (error) {
                            console.error(error);
                            toast({
                                kind: 'error',
                                description: 'An unexpected error occurred',
                            });
                        }
                    },
                    options: [
                        {
                            value: 'public',
                            label: 'Anyone with the link',
                        },
                        {
                            value: 'workspace',
                            label: 'Workspace members only',
                        },
                        {
                            value: 'private',
                            label: 'Only me',
                        },
                    ],
                },
            },
        });
        return <View {...props}>{children}</View>;
    };
}
